import * as Scrivito from "scrivito";
import homepageObjIcon from "assets/images/homepage_obj.svg";
import FooterContainerWidget from "widgets/FooterContainerWidget/FooterContainerWidgetClass";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("HomepageSame", {
  title: "HomepageSame",
  thumbnail: homepageObjIcon,
  hideInSelectionDialogs: true,
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
    logo: {
      title: "Logo",
      description: "General nav attribute: sets the logo",
    },
    configuratorLogo: {
      title: "Configurator logo",
      description: "Logo for configurator navigation",
    },
    dividerLogo: {
      title: "Divider logo",
      description: "Used in the divider widget",
    },
    facebookAppId: {
      title: "Facebook app ID",
      description:
        "Register at https://developers.facebook.com/docs/apps/register",
    },
    twitterSite: {
      title: "Twitter site",
      description:
        "Needs to be approved at https://cards-dev.twitter.com/validator",
    },
    googleMapsApiKey: {
      title: "Google Maps API key",
      description:
        "Needs to be requested at https://developers.google.com/maps/web/",
    },
    cookieConsentLink: {
      title: "Cookie consent link",
      description:
        'If you set this link, a cookie consent box will be shown on every page. The link should point to your privacy policy. The link title defaults to "Learn more »".',
    },
    navigationFooterLinks: {
      title: "Navigation Footer",
    },
    navigationServiceLinks: {
      title: "Main navigation Service",
      description: "General nav attribute: sets upper links",
    },
    configuratorNavigationServiceLinks: {
      title: "Configurator navigation Service",
      description: "Navigation links in configurator right sidebar",
    },
    configuratorNavTitle: {
      title: "Translation Configurator title",
      description: "Title in header of Configurator",
    },
    configuratorNavMenu: {
      title: "Translation for 'Menu'",
      description: "'Menu' in Configurator sidebar",
    },
    configuratorNavLogin: {
      title: "Translation for 'Login' button",
      description: "Button 'Login' in Configurator at the bottom of sidebar",
    },
    configuratorNavExit: {
      title: "Translation for 'Exit' button",
      description:
        "Button 'Exit' (logout) in Configurator at the bottom of sidebar",
    },
    configLeftSidebarProjectRefs: {
      title: "Left Sidebar Project References",
      description: `Lets the user to config Left Sidebar Project item.
       It's used in Configurator pages like i.e. ProjectConfigurator, ProductList, LibraryList, etc.`,
    },
    configLeftSidebarProductsRefs: {
      title: "Left Sidebar Products References",
      description: `Lets the user to config Left Sidebar Product item.
       It's used in Configurator pages like i.e. ProjectConfigurator, ProductList, LibraryList, etc.`,
    },
    configLeftSidebarLibraryRefs: {
      title: "Left Sidebar Library References",
      description: `Lets the user to config Left Sidebar Library item.
       It's used in Configurator pages like i.e. ProjectConfigurator, ProductList, LibraryList, etc.`,
    },
    configLeftSidebarAdminRefs: {
      title: "Left Sidebar Admin References",
      description: `Lets the user to config Left Sidebar Admin item.
       It's used in Configurator pages like i.e. ProjectConfigurator, ProductList, UsrList, etc.`,
    },
    configLeftSidebarHelpRefs: {
      title: "Left Sidebar Help References",
      description: `Lets the user to config Left Sidebar Help item.
       It's used in Configurator pages like i.e. ProjectConfigurator, ProductList, LibraryList, etc.`,
    },
    welcomePage: {
      title: "Configurator Welcome Page",
      description: `Lets the user to config Configurator Welcome Page.
       It's used in Configurator pages like i.e. ProjectConfigurator, ProductList, LibraryList, etc.`,
    },
  },
  properties: [...defaultPageProperties],
  propertiesGroups: [
    {
      title: "Site settings",
      properties: [
        "dividerLogo",
        "cookieConsentLink",
        "facebookAppId",
        "twitterSite",
        "googleMapsApiKey",
        "headerSocialMediaLinks",
      ],
    },
    {
      title: "Navigation settings",
      properties: [
        "logo",
        "logoLink",
        "configuratorLogo",
        "navigationServiceLinks",
        "configuratorNavigationServiceLinks",
        "configuratorNavTitle",
        "configuratorNavMenu",
        "configuratorNavLogin",
        "configuratorNavExit",
        "configLeftSidebarProjectRefs",
        "configLeftSidebarProductsRefs",
        "configWizardObjRefs",
        "configLeftSidebarLibraryRefs",
        "configLeftSidebarAdminRefs",
        "configLeftSidebarHelpRefs",
        "welcomePage",
        "projectItemPage",
        "projectConfiguratorPage",
        "productConfiguratorPage",
        "productListPage",
      ],
    },
    {
      title: "Footer settings",
      properties: [
        "navigationFooterLinks",
        "footerWidgets",
        "minimizedFooterLinks",
      ],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
    logoLink: "https://www.trox.de/",
    configuratorNavTitle: "Configurator",
    configuratorNavMenu: "Menu",
    configuratorNavLogin: "Login Configurator",
    configuratorNavExit: "Exit Configurator",
    footerWidgets: [new FooterContainerWidget({})],
    navigationFooterLinks: [],
  },
  validations: [
    ...defaultPageValidations,
    ...metadataValidations,
    [
      "logo",
      (logo) => {
        if (!logo) {
          return {
            message: "Logo is required",
            severity: "error",
          };
        }
      },
    ],
    [
      "configuratorLogo",
      (configuratorLogo) => {
        if (!configuratorLogo) {
          return {
            message: "Configurator logo is required",
            severity: "error",
          };
        }
      },
    ],
    [
      "projectItemPage",
      (projectItemPage) => {
        if (!projectItemPage) {
          return {
            message: "Project Item reference is required",
            severity: "error",
          };
        }
      },
    ],
    [
      "projectConfiguratorPage",
      (projectConfiguratorPage) => {
        if (!projectConfiguratorPage) {
          return {
            message: "Project configurator reference is required",
            severity: "error",
          };
        }
      },
    ],
    [
      "productConfiguratorPage",
      (productConfiguratorPage) => {
        if (!productConfiguratorPage) {
          return {
            message: "Product configurator reference is required",
            severity: "error",
          };
        }
      },
    ],
    [
      "productListPage",
      (productListPage) => {
        if (!productListPage) {
          return {
            message: "Product list reference is required",
            severity: "error",
          };
        }
      },
    ],
    [
      "configLeftSidebarProjectRefs",
      (projects) => {
        const projectListsArr = projects.filter(
          (item) => item.objClass() === "ProjectListSame",
        );
        const projectItemsArr = projects.filter(
          (item) => item.objClass() === "ProjectItemSame",
        );
        const projectConfiguratorsArr = projects.filter(
          (item) => item.objClass() === "ProjectConfigurator",
        );
        if (
          projectListsArr.length > 1 ||
          projectItemsArr.length > 1 ||
          projectConfiguratorsArr.length > 1
        ) {
          return {
            message:
              "Project List, Project Item and Project Configurator Objs should be only one.",
            severity: "error",
          };
        }
        if (
          !projectListsArr.length ||
          !projectItemsArr.length ||
          !projectConfiguratorsArr.length
        ) {
          return {
            message:
              "Project List, Project Item and Project Configurator Objs are required.",
            severity: "error",
          };
        }
      },
    ],
  ],
});
